import { render, staticRenderFns } from "./OgLaboralDocuments.vue?vue&type=template&id=563b7710&"
import script from "./OgLaboralDocuments.vue?vue&type=script&lang=js&"
export * from "./OgLaboralDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OgLaboralDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports